import { Box } from "@mui/material"
import { FlowHubHeroHeader } from "./components/FlowHubHeroHeader"
import { FlowHubHeroCards } from "./components/FlowHubHeroCards"


export const FlowHubHero = () => {
    return (
        <Box sx={{ flexShrink: 0 }}>
            <FlowHubHeroHeader />
            <FlowHubHeroCards />
        </Box>
    )
}
